import type { SpoilerLevel } from "@/lib/timeline/view/TimelineUiPreferences/prefs";

interface SpoilerLevelSelectProps {
  level: SpoilerLevel;
  onChange: (level: SpoilerLevel) => void;
}

export function SpoilerLevelSelect({ level, onChange }: SpoilerLevelSelectProps) {
  return (
    <label className="timeline-options__check">
      <span>Spoilers</span>
      <select
        className="timeline-options__select"
        value={level}
        onChange={(event) => {
          onChange(event.target.value as SpoilerLevel);
        }}
      >
        <option value="off">Off</option>
        <option value="enabled">Enabled</option>
        <option value="shown">Shown</option>
      </select>
    </label>
  );
}
